import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { PAGE_ROUTE } from '~/constants';
import ErrorImage from '~/assets/img/completion_images/404.png';

export default function CharacterDetailError() {
  const handleHomeClick = () => {
    window.location.href = PAGE_ROUTE.MAIN;
  };

  return (
    <Container>
      <InfoBox>
        <img src={ErrorImage} alt={'404_error_image'} />
        <p>Character Not Found</p>
      </InfoBox>
      <ButtonBox>
        <Button onClick={handleHomeClick}>Go home</Button>
      </ButtonBox>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-align: center;
  gap: 40px;
`;

const InfoBox = styled.div`
  ${({ theme }) => css`
    display: block;

    img {
      display: block;
      width: auto;
      max-width: 100%;
      max-height: 275px;
    }

    p {
      display: block;
      ${theme.fontStyle.title.section18_medium}
    }
  `}
`;
const ButtonBox = styled.div`
  display: block;
`;

const Button = styled.button`
  ${({ theme }) => css`
    display: block;
    width: 120px;
    height: 44px;
    border: 1px solid ${theme.stroke.stroke_1};
    border-radius: 22px;
    background: ${theme.themeColor.main_1};
    color: ${theme.content.content_dark_1};
    ${theme.fontStyle.title.section18_medium}
  `}
`;
